export default __webpack_public_path__ + "static/media/launchpad.c1af0d3d.svg";